module["exports"] = ["straat", "laan", "weg", "plantsoen", "park", "gracht", "dijk"];